import { userIsPublic } from "../utils/roles";
import { getRedirectToRegisterPage } from "../utils/url/urlUtils";
import { PRODUCT_COMPARISON_PAGE } from "../utils/url/staticUrls";

const augmentUrlWithProductCode = (url: string, productCode?: string) => {
  const containsQuery = url.includes("?");
  return url + (containsQuery ? "&" : "?") + "productCode" + "=" + productCode;
};
export const getProductComparisonNavigationEntryUrl = (productCode?: string) => {
  return userIsPublic()
    ? getRedirectToRegisterPage({
        targetPage: augmentUrlWithProductCode(PRODUCT_COMPARISON_PAGE, productCode),
        openLogin: true,
      })
    : PRODUCT_COMPARISON_PAGE;
};
